module.exports = __webpack_public_path__ + "img/logosvg.a4c8d491.svg";